var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnfoldMore = function SvgUnfoldMore(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 18.1 2.325-2.325q.3-.3.725-.3t.725.3.3.725-.3.725L12.7 20.3q-.15.15-.325.212a1.1 1.1 0 0 1-.375.063q-.2 0-.375-.062a.9.9 0 0 1-.325-.213l-3.075-3.075q-.3-.3-.3-.725t.3-.725.725-.3.725.3zM12 6 9.675 8.325q-.3.3-.725.3a.99.99 0 0 1-.725-.3q-.3-.3-.3-.725t.3-.725L11.3 3.8q.15-.15.325-.212.175-.063.375-.063t.375.063a.9.9 0 0 1 .325.212l3.075 3.075q.3.3.3.725t-.3.725-.725.3a.99.99 0 0 1-.725-.3z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnfoldMore);
export { ForwardRef as ReactComponent };